import { Component } from '@angular/core';
import { GroupListComponent } from '../../lists/group-list/group-list.component';

@Component({
    selector: 'app-developer-application-groups',
    templateUrl: './developer-application-groups.component.html',
    styleUrls: ['./developer-application-groups.component.scss'],
    standalone: true,
    imports: [GroupListComponent]
})
export class DeveloperApplicationGroupsComponent {

}
